import { useFitScale } from "./useFitScale";

/**
 * MinigameStage — a fixed virtual design space scaled to fit its container.
 *
 * Children render into a constant `designW × designH` coordinate box (default
 * 600×600, square). The box is visually scaled with `transform: scale()` so it
 * looks — and, crucially, *plays* — identically at every screen size: all
 * minigame physics run in the fixed virtual space regardless of on-screen px.
 *
 * This is the reusable consistency primitive from the Junk Minigames plan; a
 * later pass can wrap the live game board in it too.
 */
export default function MinigameStage({
  designW = 600,
  designH = 600,
  className = "",
  children,
}) {
  const { wrapperRef, scale } = useFitScale(designW, designH);
  return (
    <div
      ref={wrapperRef}
      className={`relative w-full h-full flex items-center justify-center overflow-hidden ${className}`}
    >
      <div
        style={{
          width: designW,
          height: designH,
          flexShrink: 0,
          transform: `scale(${scale})`,
          transformOrigin: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
}
